import storage from 'store';
import { loadLanguageAsync } from '@/i18n';
import { APP_LANGUAGE } from '@/store/mutation-types';

const app = {
  state: {
    lang: 'vi'
  },
  getters: {},
  mutations: {
    [APP_LANGUAGE](state, lang) {
      state.lang = lang;
      storage.set(APP_LANGUAGE, lang);
    }
  },
  actions: {
    setLang({ commit }, lang) {
      return new Promise((resolve, reject) => {
        commit(APP_LANGUAGE, lang);
        loadLanguageAsync(lang)
          .then((_) => {
            resolve();
          })
          .catch((e) => reject(e));
      });
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js